module.exports = __webpack_public_path__ + "static/media/btn_parents_06_more_resources_on_parenting.ec7ad7c4.png";